import React, { Fragment } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const MapMarker = props => {
	const { $hover, highlighted, title, message } = props;

	return (
		<Fragment>
			<i
				className={classNames("rk-mapmarker rkf rkf-rollkall-shield", {
					hovered: $hover,
					highlightedScale: highlighted,
				})}
			/>
			<If condition={(title || message) && $hover}>
				<div className="marker-info">
					{title && <strong>{title}</strong>}
					<br className={title && message ? "" : "hidden"} />
					{message}
				</div>
			</If>
		</Fragment>
	);
};

MapMarker.propTypes = {
	$hover: PropTypes.bool,
	highlighted: PropTypes.bool,
	title: PropTypes.string,
	message: PropTypes.string,
};

MapMarker.defaultProps = {
	$hover: false,
	highlighted: false,
	title: "",
	message: "",
};

export default MapMarker;
